<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ebcGCC/image/cover.jpg?1708992365032" alt="This image is the cover for the book Hannah Comes Home and Other Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hannah Comes Home and Other Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>Step into the enchanting world of Baby Hannah, a spirited baby girl who discovers the remarkable power of love and family in this delightful collection of short stories. From the moment she arrived at her new home, just two days old, Baby Hannah knew she had found her forever family. With three loving sisters, doting parents, and playful grandparents, every day is an adventure filled with laughter, love, and hilarious escapades. Join Hannah as she embarks on wild and crazy adventures that will tickle your funny bone and warm your heart! From attempting a trip to the zoo with her older sisters, to getting into mischief with the family dog, each story is filled with whimsy and laughter. But it’s not just about the laughter. This heartwarming collection also explores the poignant moments of being part of a loving and diverse family. Through the ups and downs, Hannah and her family learn the importance of acceptance, compassion, and the incredible bond that comes with being loved unconditionally. With endearing characters, charming illustrations, and five enchanting tales, Hannah Comes Home and Other Stories is a book that will captivate young readers and parents alike. Filled with humour and overflowing with love, this collection will remind you of the extraordinary joy that comes from being part of a family that cherishes you just the way you are. Get ready for endless giggles and heartwarming moments as you dive into Baby Hannah’s world!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hazel Govender
      </h2>
      
      <p class="authorDescription body article">Born in a tiny village called Estcourt, at the foothills of the Drakensburg Mountains, in an apartheid South Africa, Hazel Govender is a true African at heart. She completed her schooling and her undergraduate degree in South Africa. Married to Theo Govender, the couple were happily raising 3 daughters, when they had a magical encounter with Baby Hannah in 2013. Hannah came home at 2 days old and become the youngest daughter of the family. In 2015 the family relocated to the UAE and are living in Abu Dhabi. Hazel is the CEO and Principal at GEMS Cambridge International School, Abu Dhabi and holds a Masters Degree in Educational Leadership and Management, with the University of Portsmouth, UK. Hazel Govender is an educationalist who continues to change the world, one child at a time. This is the author’s first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72c5e1ab